export const isServerClosedSession = (err: Error | undefined): boolean =>
  err?.message?.includes('Server returned an error on close') ?? false
